/**
 * TanStack Query hooks for `export-permission-csv-xlsx-per-role`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	exportPermissionCsvXlsxPerRoleQueryKeys,
	type CreateExportPermissionCsvXlsxPerRoleBody,
	type ListExportPermissionCsvXlsxPerRoleResponse,
	type ExportPermissionCsvXlsxPerRoleRow,
} from "./api";

export function useExportPermissionCsvXlsxPerRoleList(): UseQueryResult<ListExportPermissionCsvXlsxPerRoleResponse, Error> {
	return useQuery({
		queryKey: exportPermissionCsvXlsxPerRoleQueryKeys.list(),
		queryFn: list,
	});
}

export function useExportPermissionCsvXlsxPerRoleCreate(): UseMutationResult<ExportPermissionCsvXlsxPerRoleRow, Error, CreateExportPermissionCsvXlsxPerRoleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: exportPermissionCsvXlsxPerRoleQueryKeys.all });
		},
	});
}

export function useExportPermissionCsvXlsxPerRoleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: exportPermissionCsvXlsxPerRoleQueryKeys.all });
		},
	});
}
